import React, {ReactNode, useEffect, useState} from "react";
import {Filters} from "../../types/filterTypes";
import {LoadError} from "../../types/generic";
import {HierarchyFootball, MamData, MamSummary} from "../../types/mamTypes";
import {useTheme} from "../../contexts/theme";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import TransparentButtonSelection from "../CommonComponents/TransparentButtonSelection/TransparentButtonSelection";
import PageContainer from "../CommonComponents/PageContainer/PageContainer";
import matchboardBackground from "../../assets/images/Matchboard/InBriefBackground1.png";
import MatchDayContainer from "./MatchDayContainer";
import {MamClipElement} from "../../types/clipTypes";
import {useMamInformation} from "../../contexts/MamInformation";
import {useMamSummary} from "../../contexts/mamSummary";
import StyledIconButton from "../CommonComponents/StyledIconButton/StyledIconButton";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import StyledDrawerComponent from "../CommonComponents/StyledDrawerComponent/StyledDrawerComponent";
import axios from "axios";
import axiosInstance from "../../queries/axiosInstance";
import {useActiveFilters} from "../../contexts/activeFilters";
import {Competition} from "../../types/competitionTypes";
import SpinnerBox from "../CommonComponents/SpinnerBox/SpinnerBox";
import MatchDaysMamSkeleton from "./MamSkeleton/MatchDaysMamSkeleton";


interface mamContentProps {
    competition: string;
    setCompetition: (competition: string) => void;
}


export default function CompetitionContainer({
                                                 setCompetition,
                                                 competition
                                             }: mamContentProps) {


    const theme = useTheme();
    const [drawerOpen, setDrawerOpen] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);

    const {information} = useMamInformation();
    const {setInformation, setUpdateLoading} = useMamInformation();

    const {activeFilters} = useActiveFilters();


    const {summary} = useMamSummary();
    const {setSummary} = useMamSummary();

    const handleCompetition = (competitionValue: string) => {
        setLoading(true);

        const tempSummary = {...summary};
        tempSummary.competition = competitionValue;
        tempSummary.matchDay = []
        tempSummary.match = []
        setCompetition(competitionValue);
        setSummary(tempSummary);

        getDataOnDemand(competitionValue).then(r => {
            // console.log("COMPETITION CONTAINER ",r);
            const tempInformation = {...information!};
            tempInformation.matchDay = []
            tempInformation.matchDayEvents = []
            r.matchDays.map((item: any)=>{
                tempInformation.matchDay.push(item);
            })
            r.events.map((value: any) => {
                tempInformation.matchDayEvents.push(value);
            })
            /*

            r.events.map((item: any)=>{
                tempInformation.matchDayEvents.push(item);
            })*/
            setInformation(tempInformation);
            setLoading(false);
        });

    }

    const getDataOnDemand = async (competition: string) =>{
        try{
            setUpdateLoading(true);
            const response = await axiosInstance.post('/assets/matchDays', {
                competition: competition,
                includeMostRecentEvents: true,
                filters: activeFilters
            });
            return response.data;
        } catch (errorCompetition) {
            console.error("Error Competition", JSON.stringify(errorCompetition));
        }finally {
            setUpdateLoading(false);
        }
    }


    return (

        <Box sx={{
            padding: theme.spacing.md,
        }}
        >
            {information && (
                <Box sx={{paddingBottom: theme.spacing.md}}>
                    <TransparentButtonSelection options={information.competitions} onChange={handleCompetition}
                                                value={competition} valueField={"id"} labelField={"name"}/>
                </Box>)}

            {loading ? (
                    <MatchDaysMamSkeleton skeletonNumber={10}/>) :

                (<MatchDayContainer competition={competition}/>

                )}


        </Box>


    );


}